import script from "./WxPublic.vue?vue&type=script&setup=true&lang=js"
export * from "./WxPublic.vue?vue&type=script&setup=true&lang=js"

import "./WxPublic.vue?vue&type=style&index=0&id=f3698eb6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f3698eb6"]])

export default __exports__